import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import * as ol from 'openlayers';
import {EditionLayer} from '../../models/edition-layer';

@Component({
  selector: 'app-expansion-panel-list',
  templateUrl: './expansion-panel-list.component.html',
  styleUrls: ['./expansion-panel-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ExpansionPanelListComponent {
  @Output() geolocateFeatureClicked = new EventEmitter<any>();
  @Output() featureClicked = new EventEmitter<any>();
  @Input() editionLayerReceived: EditionLayer;
  @Input() sidenav: any;
  @Input() features: any[] = [];

  public selectedFeature: any = null;

  constructor() {}

  public togglePanel(feature: any): void {
    this.selectedFeature = this.selectedFeature === feature ? null : feature;
  }

  public trackByFeature(index: number, feature: any): number {
    return feature.properties.gid;
  }

  public getFeatureValues(feature: any): { label: string, value: any }[] {
    if (!feature.properties || !this.editionLayerReceived.atributs) {
      return [];
    }
    return this.editionLayerReceived.atributs
      .filter(attr => attr.format !== 'F' && attr.format !== 'S')
      .map(attr => ({
        label: attr.camp,
        value: feature.properties[attr.camp]
      }))
      .filter(item => item.value !== undefined);
  }

  public openEditionFeatureMode(feature: any) {
    const olFeature = new ol.Feature(feature.properties);
    olFeature.setGeometry(new ol.geom.Point(feature.geometry.coordinates));
    olFeature.setId(feature.id);
    this.featureClicked.emit({
      feature: olFeature,
      layer: this.editionLayerReceived
    });
  }

  public geolocateFeature(feature: any) {
    const olFeature = new ol.Feature(feature.properties);
    olFeature.setGeometry(new ol.geom.Point(feature.geometry.coordinates));
    this.geolocateFeatureClicked.emit(olFeature);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/expansion-panel-list/expansion-panel-list.component.ts